module.exports = __webpack_public_path__ + "img/koedboller_done.e8793b68.jpg";